export const header = {
    fullName: 'Theerut (Top) Foongkiatcharoen',
    address: 'Bangkok, Thailand',
    tel: '098-248-3588',
    email: 'theeruttop@gmail.com',
    urls: [
        'https://linkedin.com/in/theerut-foongkiatcharoen/',
        'https://github.com/topkoong/',
        'https://topkoong.github.io/',
    ],
};
export const skills = [
    {
        category: 'Languages',
        content: 'JavaScript | TypeScript | Java | Go | Python | C# | C++',
    },
    {
        category: 'Web Technologies',
        content: 'React | Redux | Next.js | Node.js | NestJS | Apollo GraphQL | Spring WebFlux | Spring Boot | Vue | Svelte | Express | Fastify | SCSS | Kafka | RabbitMQ | TailwindCSS | Material-UI | Vite | Electron.js',
    },
    {
        category: 'Databases & Cloud',
        content: 'PostgreSQL | MongoDB | MySQL | Redis | AWS | Azure | GCP | Kubernetes | Docker',
    },
    {
        category: 'Tools & Platforms',
        content: 'Jenkins | GitLab | GitHub Actions | OpenAPI | Swagger | Kong API Gateway | ELK Stack | Grafana | Prometheus | Dynatrace | Istio',
    },
];
export const educations = [
    {
        school: 'Fullstack Academy',
        degree: 'Software Engineering Immersive',
        location: 'New York, NY',
        graduated: 'Feb 2019',
    },
    {
        school: 'Syracuse University',
        degree: 'Master of Science in Computer Engineering',
        location: 'Syracuse, NY',
        graduated: 'May 2018',
    },
    {
        school: `King Mongkut's Institute of Technology Ladkrabang`,
        degree: 'Bachelor of Engineering in Computer Engineering',
        location: 'Bangkok, TH',
        graduated: 'March 2014',
    },
];
export const workExperiences = [
    {
        title: 'Application Development Associate Manager (Technical/Solutions Architect, CardX Thailand)',
        company: 'Accenture',
        dateRange: 'Feb 2024 – Present',
        location: 'Bangkok, TH',
        descriptions: [
            '<strong>EOD Batch Job Log and Dashboard Improvement in Kibana:</strong> Improved time to analyze EOD Batch Job Performance for the core system.',
            '<strong>Vault Implementation and Single-Sign-On Implementation:</strong> Improved security operations by reducing human intervention steps and aligning secret management between core application teams',
            '<strong>DataX Initialization and VIN Initialization:</strong> Led and managed migration activities for CardX Pilot and Post-Mass Migration by creating data flow documentation and deployment runbooks, tracking execution through multiple dress rehearsals, and coordinating deployment efforts between CardX, Accenture, and DataX teams to ensure all parties were aligned',
        ],
    },
    {
        title: 'Application Development Associate Manager (Performance Test Lead, TTB Touch, TTB)',
        company: 'Accenture',
        dateRange: 'Aug 2023 – Jan 2024',
        location: 'Bangkok, TH',
        descriptions: [
            '<strong>Performance Test Automation:</strong> Led team in developing JMeter scripts and Karate mock APIs for legacy systems, established Grafana/Prometheus monitoring for Redis performance, and implemented Jenkins pipeline integration for automated performance testing.',
            '<strong>Sprint Integration & Developer Enablement:</strong> Designed performance testing framework within Sprint cycles enabling both Accenture and TTB developers to independently identify performance bottlenecks, resulting in early issue detection and reduced fix costs.',
        ],
    },
    {
        title: 'Application Development Associate Manager (Technical/Solutions Architect, SCB Thailand)',
        company: 'Accenture',
        dateRange: 'Mar 2023 – Jul 2023',
        location: 'Bangkok, TH',
        descriptions: [
            '<strong>Solution Design & Technical Analysis:</strong> Contributed to architectural discussions for mainframe-to-Azure migration projects, assisted in defining solution requirements and system components, and supported technical design efforts for modernizing on-premises workloads to managed cloud environments.',
            '<strong>Client Information Gathering & Technical Support:</strong> Supported client engagement as technical liaison, gathered requirements and system information from customers, and assisted in developing solution roadmaps aligned with enterprise technology guidelines',
        ],
    },
    {
        title: 'Application Development Associate Manager (AI & Chatbot Technical Lead, CardX Thailand)',
        company: 'Accenture',
        dateRange: 'Mar 2022 – Nov 2022',
        location: 'Bangkok, TH',
        descriptions: [
            '<strong>Chatbot Solution Development:</strong> Led technical team in designing and developing chatbot application for CardX using React and Spring WebFlux, integrated with Facebook Messenger and Line OA through Google Dialogflow ES, enabling multi-channel customer engagement.',
            '<strong>Full-Stack Validation Platform:</strong> Built comprehensive intent validation website using Next.js and Node.js, allowing bank clients to review and validate chatbot intents, streamlining the bot training and quality assurance process.',
            '<strong>Deployment Automation & Testing:</strong> Created automated deployment program for Google Dialogflow ES flows with one-click migration across environments (dev/staging/prod), including integrated chatbot testing capabilities to streamline development workflow.',
        ],
    },
    {
        title: 'Remote Full-Stack Developer',
        company: 'ShopLIVE',
        dateRange: 'May 2021 – Apr 2022 (Part-time)',
        location: 'Bangkok, TH',
        descriptions: [
            '<strong>Full-Stack Development:</strong> Built GraphQL server using SDL-first approach with Prisma and PostgreSQL database, while developing frontend applications using Preact and Tailwind UI for modern web experiences.',
            '<strong>Social Media Integration:</strong> Implemented comprehensive social media automation and messaging app consolidation including Facebook, Line, and other social channels across web and mobile platforms.',
        ],
    },
    {
        title: 'Application Development Specialist (Frontend Development SME, SCB Business Anywhere, SCB Thailand)',
        company: 'Accenture',
        dateRange: 'Sep 2020 – Mar 2022',
        location: 'Bangkok, TH',
        descriptions: [
            '<strong>Frontend Technical Leadership:</strong> Led frontend development teams as Subject Matter Expert, architecting and developing React-based corporate portal applications for multinational banking clients, mentoring junior developers, and establishing software quality standards across cross-functional teams.',
            '<strong>UI/UX Implementation & Team Management:</strong> Collaborated with UI/UX designers to deliver responsive, cross-browser compatible applications using React, Redux, and modern frontend frameworks, while supervising development squads and participating in peer-reviews of solution designs and code.',
        ],
    },
    {
        title: 'Software Engineer',
        company: 'Refinitiv (formerly the Financial and Risk business of Thomson Reuters)',
        dateRange: 'Aug 2019 – Aug 2020',
        location: 'Bangkok, TH',
        descriptions: [
            '<strong>Pioneered Excel custom functions:</strong> to build solutions that extend Office applications and interact with content in Office documents',
            '<strong>Constructed Office Platform service:</strong> which is a single platform sharing services and providing the same capability among all clients including Office 365 Add-ins, (Native) Office, and other clients',
            '<strong>Formulated Refitiniv Add-ins platform:</strong> for Office 365 such as Excel add-in and Excel custom functions to work towards solutions that extend Office applications and interact with content in Office documents mobilizing Refinitiv Financial Solutions',
            '<strong>Created Office Platform service:</strong> which is a single platform sharing services and providing the same capability among all clients including Office 365 Add-ins, (Native) Office, and other clients',
            '<strong>Generated digital financial products:</strong> on the market utilizing Refinitiv Financial data to make confident business decisions',
        ],
    },
    // {
    //   title: 'Full Stack Developer',
    //   company: 'Trainor',
    //   dateRange: 'June 2018 – Sept 2018',
    //   location: 'New Hartford, NY',
    //   descriptions: [
    //     // 'Integrated open-source software with SilverStripe (a free and open-source Content Management System and Framework) and upgraded supporting modules to support newer releases of the core software',
    //     'Collaborated with the Application UI/UX Designer to develop cross-browser and multi-browser compatible web pages for all clients',
    //     'Created a scalable and modular architecture for CSS using the Organizable and Maintainable SCSS framework',
    //   ],
    // },
    // {
    //   title: 'Web Developer Co-op',
    //   company: 'Docere eLearning Solutions',
    //   dateRange: 'Oct 2016 – Jan 2017',
    //   location: 'Lawton, OK',
    //   descriptions: [
    //     'Designed, implemented database of vocabulary lessons, videos, games, and quizzes, and collaborated with the graphic designer',
    //   ],
    // },
    // {
    //   title: 'Cyber Security Analyst',
    //   company: 'Deloitte Touche Tohmatsu',
    //   dateRange: 'Apr 2014 – Dec 2014',
    //   location: 'Bangkok, TH',
    //   descriptions: [
    //     'Cyber Risk Services (CRS), Data Leakage Prevention (DLP), and Contract Risk & Compliance (CRC)',
    //   ],
    // },
];
